import { buildStackedColumnBarOptions } from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/stackedColumnBarConfig'

export const buildStackedBarOptions = props => {
  const result = buildStackedColumnBarOptions(props)
  if (!result) return null

  const { options } = result
  const { chartLegendMode } = props

  options.chart.type = 'bar'
  options.chart.defaultSeriesType = 'bar'
  options.chart.marginRight = 43
  options.chart.marginBottom = 50
  options.chart.marginLeft = chartLegendMode === 'short' ? 85 : 130

  options.plotOptions.bar = { groupPadding: 0.05 }

  delete options.xAxis.labels.step
  delete options.xAxis.labels.y

  // Dynamic height
  const series = options.series || []
  const barsCount = series[0]?.data?.length || 0

  if (barsCount > 0) {
    const chartHeight = options.chart.height || 426
    const correctedHeight = chartHeight + 40 * (barsCount - 7)
    options.chart.height = correctedHeight
    if (options.chart.backgroundColor?.linearGradient) {
      options.chart.backgroundColor.linearGradient = [0, 0, 0, correctedHeight]
    }
  }

  return result
}
